import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-auto-open-menu',
    imports: [MatMenuModule],
    templateUrl: './auto-open-menu.component.html',
    styleUrl: './auto-open-menu.component.scss'
})
export class AutoOpenMenuComponent {
  timedOutCloser?: any;

  mouseEnter(trigger: any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger: any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }
}
